import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './RegisterPage.mobile.css';

// 定義內聯樣式
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 37px)',
    height: 'calc(100vh - 37px)',
    padding: '20px',
    marginTop: 0,
    backgroundColor: '#f8f9fa',
    top: '37px',
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
    width: '100vw', // ← ① 強制鋪滿整個視窗寬
    boxSizing: 'border-box', // ← ② 讓 padding 算在寬度裡
  },
  card: {
    width: '90%',
    maxWidth: '380px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    padding: '30px',
    transition: 'transform 0.3s ease',
    position: 'relative',
  },
  header: {
    textAlign: 'center',
    marginBottom: '25px',
  },
  title: {
    color: '#333',
    fontSize: '26px',
    marginBottom: '8px',
    fontWeight: 600,
  },
  subtitle: {
    color: '#666',
    fontSize: '15px',
  },
  error: {
    backgroundColor: '#fff0f0',
    color: '#e74c3c',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '15px',
    fontSize: '14px',
    borderLeft: '4px solid #e74c3c',
    width: '85%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '18px',
    width: '100%',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '85%',
    maxWidth: '300px',
    gap: '6px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#333',
    alignSelf: 'flex-start',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '10px',
    width: '85%',
    maxWidth: '300px',
  },
  emailButton: {
    width: '150px',
    padding: '11px',
    backgroundColor: '#2a7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  emailInput: {
    width: '200px',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  formActions: {
    width: '85%',
    maxWidth: '300px',
    marginTop: '5px',
  },
  button: {
    width: '100%',
    padding: '11px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '85%',
    maxWidth: '300px',
    marginTop: '15px',
    fontSize: '13px',
  },
  link: {
    color: '#8e7a55',
    textDecoration: 'none',
    transition: 'color 0.3s',
  },
  backButton: {
    position: 'absolute',
    top: '15px',
    left: '15px',
    background: 'none',
    border: 'none',
    color: '#8e7a55',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
  },
  backIcon: {
    marginRight: '5px',
  },
  // 模態框樣式
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    maxWidth: '350px',
    width: '90%',
    textAlign: 'center',
    position: 'relative',
  },
  modalHeader: {
    marginBottom: '15px',
    color: '#8e7a55',
    fontSize: '20px',
    fontWeight: 600,
  },
  modalText: {
    marginBottom: '20px',
    fontSize: '15px',
    lineHeight: '1.5',
    color: '#555',
  },
  modalButton: {
    padding: '8px 20px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  modalCloseButton: {
    position: 'absolute',
    top: '10px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '22px',
    color: '#999',
    cursor: 'pointer',
    lineHeight: 1,
  },
};

const NotificationModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <div style={styles.modal} onClick={onClose}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button style={styles.modalCloseButton} onClick={onClose}>
          ×
        </button>
        <h3 style={styles.modalHeader}>{title}</h3>
        <p style={styles.modalText}>{message}</p>
        <button style={styles.modalButton} onClick={onClose}>
          {onClose && typeof onClose === 'function' ? 'Confirm' : 'Close'}
        </button>
      </div>
    </div>
  );
};

const RegisterPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
    invitationCode: '',
    emailVerificationCode: '',
  });

  const [error, setError] = useState('');
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [modal, setModal] = useState({
    isOpen: false,
    title: '',
    message: '',
  });

  // 使用正則檢查 email 格式
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isEmailValid = emailRegex.test(formData.email);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // 發送郵箱確認，寄出驗證碼郵件
  const handleEmailConfirm = async () => {
    if (!formData.email) {
      setModal({
        isOpen: true,
        title: t('register.emailErrorTitle', 'error'),
        message: t('register.emptyEmail123', 'Please enter email'),
      });
      return;
    }
    // 如果 email 格式不正確
    if (!isEmailValid) {
      setModal({
        isOpen: true,
        title: t('register.emailErrorTitle', 'error'),
        message: t('register.invalidEmail123', 'please enter correct format'),
      });
      return;
    }
    try {
      const preferredLanguage =
        localStorage.getItem('selectedLanguage') || 'en';
      const payload = {
        email: formData.email,
        username: formData.username,
        preferredLanguage,
      };

      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      console.log('Email sent:', data);
      setModal({
        isOpen: true,
        title: t('emailSentTitle', '郵箱驗證碼已寄出'),
        message: t('emailSentMessage', '請檢查您的郵箱以取得驗證碼'),
      });
    } catch (error) {
      console.error('Error sending email:', error);
      setModal({
        isOpen: true,
        title: t('emailErrorTitle', '錯誤'),
        message: t('emailErrorMessage', '郵箱發送失敗，請稍後再試'),
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (
      !formData.username ||
      !formData.password ||
      !formData.email ||
      !formData.invitationCode ||
      !formData.emailVerificationCode
    ) {
      setError(t('register.errorEmptyFields', '請填寫所有欄位'));
      return;
    }

    try {
      const response = await axios.post('/api/register', formData, {
        headers: { 'Content-Type': 'application/json' },
      });
      console.log('Registration successful:', response.data);
      setRegistrationSuccess(true);
      setModal({
        isOpen: true,
        title: t('register.successTitle', '註冊成功'),
        message: t('register.successMessage', '您的帳戶已成功註冊！'),
      });
    } catch (err) {
      console.error(
        'Registration error:',
        err.response ? err.response.data : err
      );
      setError(
        t(
          'register.errorRegister',
          err.response ? err.response.data.error : '註冊失敗'
        )
      );
    }
  };

  const closeModal = () => {
    setModal({ ...modal, isOpen: false });
    if (registrationSuccess) {
      navigate('/login');
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <button onClick={handleGoBack} style={styles.backButton}>
          <span style={styles.backIcon}>←</span>
          {t('register.back', '返回上一頁')}
        </button>

        <div style={styles.header}>
          <h1 style={styles.title}>
            {t('register.title', 'Experimental Auth Module')}
          </h1>
          <p style={styles.subtitle}>
            {t(
              'register.subtitle',
              'This registration flow is for testing only and is not an active production login system.'
            )}
          </p>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          {/* 用戶名 */}
          <div style={styles.formGroup}>
            <label htmlFor="username" style={styles.label}>
              {t('register.username', '用戶名')}
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder={t('register.usernamePlaceholder', '請輸入用戶名')}
              style={styles.input}
            />
          </div>

          {/* 密碼 */}
          <div style={styles.formGroup}>
            <label htmlFor="password" style={styles.label}>
              {t('register.password', '密碼')}
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder={t('register.passwordPlaceholder', '請輸入密碼')}
              style={styles.input}
            />
          </div>

          {/* Email 與 Email Confirm 按鈕合併為一行，按鈕放在右邊 */}
          <div style={styles.rowContainer} className="rowContainer">
            <div style={styles.formGroup}>
              <label htmlFor="email" style={styles.label}>
                {t('register.email', '郵箱')}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t('register.emailPlaceholder', '請輸入郵箱')}
                style={styles.emailInput}
                className="emailInput"
              />
            </div>
            <button
              type="button"
              onClick={handleEmailConfirm}
              style={styles.emailButton}
              className="emailButton"
            >
              {t('register.emailConfirm', '郵箱確認')}
            </button>
          </div>

          {/* 郵箱驗證碼 */}
          <div style={styles.formGroup}>
            <label htmlFor="emailVerificationCode" style={styles.label}>
              {t('register.emailVerificationCode', '郵箱驗證碼')}
            </label>
            <input
              type="text"
              id="emailVerificationCode"
              name="emailVerificationCode"
              value={formData.emailVerificationCode}
              onChange={handleChange}
              placeholder={t(
                'register.emailVerificationCodePlaceholder',
                '請輸入郵箱驗證碼'
              )}
              style={styles.input}
            />
          </div>

          {/* 邀請碼 */}
          <div style={styles.formGroup}>
            <label htmlFor="invitationCode" style={styles.label}>
              {t('register.invitationCode', '邀請碼')}
            </label>
            <input
              type="text"
              id="invitationCode"
              name="invitationCode"
              value={formData.invitationCode}
              onChange={handleChange}
              placeholder={t(
                'register.invitationCodePlaceholder',
                '請輸入邀請碼'
              )}
              style={styles.input}
            />
          </div>

          {/* 提交註冊 */}
          <div style={styles.formActions}>
            <button type="submit" style={styles.button}>
              {t('register.registerButton', '註冊')}
            </button>
          </div>
        </form>
      </div>

      <NotificationModal
        isOpen={modal.isOpen}
        onClose={closeModal}
        title={modal.title}
        message={modal.message}
      />
    </div>
  );
};

export default RegisterPage;
